module.exports = __webpack_public_path__ + "images/emoji/lips.c7cb57a8beeb77b8f3a4.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/lips.png
// module id = gdtd
// module chunks = 2